export abstract class Notifications {
  public abstract addAlert(message: string): void;
  public abstract addSuccess(message: string): void;
}
